import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SessionModel} from './session.model';
import {MainService} from '../main.service';

const API_URL = 'droitsacces/';

@Injectable({
	providedIn: 'root' // il permet d'ajouter ce service dans les providers 'global' de l'app
})
export class SessionService extends MainService {


	// Récupérer les droits d'accès de l'utilisateur connecté sur le dossier à utiliser
	getOne(id: number): Observable<SessionModel> {
		return this.httpGet(API_URL + id);
	}
}
